export const SUCCESS_MESSAGES = {
    UPDATE_MEMBERSHIP_SUCCESS: 'Yayy! Member has been updated!',
    PROJECT_CLOSED: 'The project has been closed successfully!',
    PROJECT_OPENED: 'The project has been opened successfully!',
};
